import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-phone-number',
  templateUrl: './phone-number.component.html',
  styleUrls: ['./phone-number.component.scss']
})
export class PhoneNumberComponent implements OnInit {

  separateDialCode = false;

  @Input()
  public inputId: string = '';

  @Input()
  public isInvalid: boolean = false;

  @Input()
  public phoneNumber: any;

  @Input()
  public disabled: boolean;

  @Output()
  public valueChanged = new EventEmitter<string>();

  constructor() {
    this.disabled = false;
  }

  ngOnInit(): void {
  }

  public onModelChanged(data: any): void {
    if (data != null || data != undefined)
      this.valueChanged.emit(data.e164Number);
  }
}
